(function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  var backdrop = drawer.querySelector("[data-cart-drawer-backdrop]");
  var panel = drawer.querySelector("[data-cart-drawer-panel]");
  var itemsEl = drawer.querySelector("[data-cart-drawer-items]");
  var subtotalEl = drawer.querySelector("[data-cart-drawer-subtotal]");
  var upsellsEl = drawer.querySelector("[data-cart-drawer-upsells]");
  var upsellsList = drawer.querySelector("[data-cart-drawer-upsells-list]");
  var freeShippingEl = drawer.querySelector("[data-cart-drawer-free-shipping]");
  var wasEl = drawer.querySelector("[data-cart-drawer-was]");
  var saveBadgeEl = drawer.querySelector("[data-cart-drawer-save]");
  var countdownEl = drawer.querySelector("[data-cart-drawer-countdown]");

  var shopUrl = (drawer.getAttribute("data-shop-url") || "").replace(/\/$/, "");
  var moneyFmt = drawer.getAttribute("data-money-format") || "{{amount}}";
  var curCode = drawer.getAttribute("data-currency") || "";
  var emptyText = drawer.getAttribute("data-empty-text") || "Your cart is empty.";
  var freeShippingThreshold = parseInt(drawer.getAttribute("data-free-shipping-threshold") || "0", 10);
  var qtyUpsellText = drawer.getAttribute("data-qty-upsell-text") || "";
  var giftThreshold = parseInt(drawer.getAttribute("data-gift-threshold") || "0", 10);
  var shippingLabel = drawer.getAttribute("data-shipping-label") || "Free shipping";
  var giftLabel = drawer.getAttribute("data-gift-label") || "Free gift";

  var upsellProducts = [];
  try {
    var upsellScript = document.getElementById("UpsellProductsJson");
    if (upsellScript && upsellScript.textContent) {
      upsellProducts = JSON.parse(upsellScript.textContent);
    }
  } catch (e) {}

  var lastFocusedEl = null;
  var countdownStarted = false;
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initCountdown() {
    if (!countdownEl || countdownStarted) return;
    countdownStarted = true;
    var storageKey = "resorse_cart_reserved_offer_end";

    function pad2(value) {
      return String(value).padStart(2, "0");
    }

    function getEndTime() {
      var stored = sessionStorage.getItem(storageKey);
      var end = stored ? parseInt(stored, 10) : 0;
      if (!end) {
        end = Date.now() + 10 * 60 * 1000;
        sessionStorage.setItem(storageKey, String(end));
      }
      return end;
    }

    function tick() {
      var secondsLeft = Math.max(0, Math.ceil((getEndTime() - Date.now()) / 1000));
      var minutes = Math.floor(secondsLeft / 60);
      var seconds = secondsLeft % 60;
      countdownEl.textContent = pad2(minutes) + ":" + pad2(seconds);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    return moneyFmt
      .replace("{{amount}}", v)
      .replace("{{amount_no_decimals}}", String(Math.round(cents / 100)))
      .replace("{{amount_with_comma_separator}}", v.replace(".", ","))
      .replace("{{amount_no_decimals_with_comma_separator}}", String(Math.round(cents / 100)))
      .replace("{{currency}}", curCode)
      .replace("{{amount_no_decimals_without_trailing_zeros}}", String(cents / 100));
  }

  function escapeHtml(s) {
    if (typeof s !== "string") return String(s);
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  // Per-unit strikethrough price (cents) stored by the PDP bundle offer
  // as a hidden line property; 0 when the line was not added via a bundle.
  function itemBundleCompareCents(item) {
    var v = item && item.properties && item.properties._compare_unit_cents;
    var n = parseInt(v, 10);
    return n > 0 ? n : 0;
  }

  function renderItem(item) {
    var img = (typeof item.image === "string" && item.image) ? item.image : null;
    var imgHtml = img
      ? '<a href="' + escapeHtml(item.url) + '" aria-hidden="true" tabindex="-1"><img src="' + escapeHtml(img) + '" alt="" width="120" loading="lazy"></a>'
      : '<div class="cart-pack__placeholder">No image</div>';
    var variantHtml = item.variant_title && item.variant_title !== "Default Title" && item.variant_title !== ""
      ? '<p class="cart-pack__variant">' + escapeHtml(item.variant_title) + "</p>"
      : "";
    variantHtml +=
        '<div class="cart-pack__qty">' +
        '<button type="button" class="cart-pack__qty-step" data-cart-qty-step="-1" aria-label="Decrease quantity">−</button>' +
        '<input id="qty-drawer-' + escapeHtml(item.key) + '" type="number" class="cart-pack__qty-input" data-cart-qty-input data-key="' +
        escapeHtml(item.key) + '" value="' + item.quantity + '" min="0" step="1" aria-label="Qty">' +
        '<button type="button" class="cart-pack__qty-step" data-cart-qty-step="1" aria-label="Increase quantity">+</button>' +
        "</div>";
    var compareHtml = "";
    var bundleCompare = itemBundleCompareCents(item) * item.quantity;
    if (bundleCompare > item.final_line_price) {
      compareHtml = '<span class="cart-pack__compare">' + formatMoney(bundleCompare) + "</span>";
    } else if (item.original_line_price !== item.final_line_price) {
      compareHtml = '<span class="cart-pack__compare">' + formatMoney(item.original_line_price) + "</span>";
    }
    return (
      '<li class="cart-pack" data-cart-line-item data-key="' +
      escapeHtml(item.key) +
      '">' +
      '<figure class="cart-pack__media">' +
      imgHtml +
      "</figure>" +
      '<div class="cart-pack__body">' +
      '<div class="cart-pack__row-title">' +
      '<h2 class="cart-pack__title"><a href="' +
      escapeHtml(item.url) +
      '">' +
      escapeHtml(item.product_title) +
      "</a></h2>" +
      "</div>" +
      '<div class="cart-pack__variant-row">' + variantHtml + "</div>" +
      (item.quantity === 1 && qtyUpsellText
        ? '<button type="button" class="cart-pack__qty-upsell" data-cart-qty-upsell data-key="' +
          escapeHtml(item.key) + '">' + escapeHtml(qtyUpsellText) + "</button>"
        : "") +
      "</div>" +
      '<div class="cart-pack__aside">' +
      '<div class="cart-pack__price">' +
      compareHtml +
      formatMoney(item.final_line_price) +
      "</div>" +
      '<button type="button" class="cart-pack__remove" data-cart-remove aria-label="Remove pack" data-key="' +
      escapeHtml(item.key) +
      '">' + TRASH_ICON + '</button>' +
      "</div>" +
      "</li>"
    );
  }

  var TRASH_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
  var TRUCK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v13H1z"/><path d="M14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="1.8"/><circle cx="17.5" cy="18.5" r="1.8"/></svg>';
  var GIFT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  function milestoneHtml(label, icon, leftPct, reached) {
    return (
      '<div class="cart-drawer__milestone' + (reached ? " is-reached" : "") + (leftPct >= 98 ? " is-end" : "") + '" style="left:' + leftPct + '%">' +
      '<span class="cart-drawer__milestone-dot"></span>' +
      '<span class="cart-drawer__milestone-icon">' + icon + "</span>" +
      '<span class="cart-drawer__milestone-label">' + escapeHtml(label) + "</span>" +
      "</div>"
    );
  }

  function renderFreeShipping(cart) {
    if (!freeShippingEl) return;
    // Gift threshold is optional; without it the bar degrades to the single
    // free-shipping milestone.
    var maxGoal = Math.max(freeShippingThreshold, giftThreshold);
    if (!maxGoal || !cart || !cart.items || !cart.items.length) {
      freeShippingEl.hidden = true;
      return;
    }

    var total = cart.total_price || 0;
    var nextGoal = 0;
    var nextLabel = "";
    if (freeShippingThreshold && total < freeShippingThreshold) {
      nextGoal = freeShippingThreshold;
      nextLabel = shippingLabel;
    } else if (giftThreshold && total < giftThreshold) {
      nextGoal = giftThreshold;
      nextLabel = giftLabel;
    }

    var text = nextGoal
      ? "Spend <strong>" + escapeHtml(formatMoney(nextGoal - total)) + "</strong> to unlock <strong>" + escapeHtml(nextLabel) + "</strong>!"
      : "You unlocked all rewards! 🎉";

    // Milestones sit at fixed 50% / 100% marks, so the fill is piecewise:
    // half the bar per stage regardless of the actual amounts.
    var shipPct = !freeShippingThreshold ? 0 : giftThreshold ? 50 : 100;
    var fillPct;
    if (!freeShippingThreshold || total >= freeShippingThreshold) {
      fillPct = giftThreshold
        ? shipPct + (100 - shipPct) * Math.min(1, (total - freeShippingThreshold) / (giftThreshold - freeShippingThreshold))
        : 100;
    } else {
      fillPct = shipPct * (total / freeShippingThreshold);
    }

    var milestones = "";
    if (freeShippingThreshold) {
      milestones += milestoneHtml(shippingLabel, TRUCK_ICON, shipPct, total >= freeShippingThreshold);
    }
    if (giftThreshold) {
      milestones += milestoneHtml(giftLabel, GIFT_ICON, 100, total >= giftThreshold);
    }

    freeShippingEl.hidden = false;
    freeShippingEl.innerHTML =
      '<p class="cart-drawer__rewards-text">' + text + "</p>" +
      '<div class="cart-drawer__rewards-track">' +
      '<div class="cart-drawer__rewards-fill" style="width:' + Math.max(0, Math.min(100, Math.round(fillPct))) + '%"></div>' +
      milestones +
      "</div>";
  }

  // Cache of variant id -> compare_at_price (cents); 0 means no compare price.
  var compareCache = {};

  function sumCompareTotal(cart) {
    var items = (cart && cart.items) || [];
    var total = 0;
    items.forEach(function (it) {
      // Prefer the bundle offer's own strikethrough price (line property)
      // so the drawer matches the compare price shown on the PDP bundle card.
      var c = itemBundleCompareCents(it) || compareCache[it.variant_id];
      var base = c && c > it.price ? c : it.price;
      total += base * it.quantity;
    });
    return total;
  }

  function renderWas(cart) {
    if (!wasEl) return;
    var items = (cart && cart.items) || [];
    if (!items.length) {
      wasEl.hidden = true;
      if (saveBadgeEl) saveBadgeEl.hidden = true;
      return;
    }

    var missingHandles = {};
    items.forEach(function (it) {
      if (compareCache[it.variant_id] === undefined && it.handle) {
        missingHandles[it.handle] = true;
      }
    });

    var handles = Object.keys(missingHandles);
    if (handles.length === 0) {
      applyWas(cart);
      return;
    }

    var pending = handles.length;
    handles.forEach(function (h) {
      fetch("/products/" + h + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (pd) {
          (pd.variants || []).forEach(function (v) {
            compareCache[v.id] = v.compare_at_price ? v.compare_at_price : 0;
          });
        })
        .catch(function () {})
        .then(function () {
          pending--;
          if (pending === 0) {
            items.forEach(function (it) {
              if (compareCache[it.variant_id] === undefined) compareCache[it.variant_id] = 0;
            });
            applyWas(cart);
          }
        });
    });
  }

  // Save badge of the chosen bundle (hidden line property); with several
  // bundle lines in the cart, the label with the highest % wins.
  function bestSaveLabel(cart) {
    var items = (cart && cart.items) || [];
    var best = "";
    var bestPct = -1;
    items.forEach(function (it) {
      var lbl = it.properties && it.properties._save_label;
      if (!lbl) return;
      var m = String(lbl).match(/(\d+(?:[.,]\d+)?)/);
      var pct = m ? parseFloat(m[1].replace(",", ".")) : 0;
      if (pct > bestPct) {
        bestPct = pct;
        best = String(lbl);
      }
    });
    return best;
  }

  function applyWas(cart) {
    if (!wasEl) return;
    var compareTotal = sumCompareTotal(cart);
    var showWas = compareTotal > cart.total_price;
    if (showWas) {
      wasEl.hidden = false;
      wasEl.textContent = formatMoney(compareTotal);
    } else {
      wasEl.hidden = true;
    }
    if (saveBadgeEl) {
      var lbl = showWas ? bestSaveLabel(cart) : "";
      if (lbl) {
        saveBadgeEl.hidden = false;
        saveBadgeEl.textContent = lbl;
      } else {
        saveBadgeEl.hidden = true;
      }
    }
  }

  function renderUpsells(cart) {
    if (!upsellsEl || !upsellsList) return;

    var cartIds = {};
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        cartIds[item.product_id] = true;
      });
    }

    var qualified = upsellProducts.filter(function (p) {
      return p && p.id && !cartIds[p.id];
    });

    if (qualified.length === 0 && cart && cart.items && cart.items.length > 0 && !upsellsEl._fetchedRecs) {
      upsellsEl._fetchedRecs = true;
      var firstId = cart.items[0].product_id;
      fetch("/recommendations/products.json?product_id=" + firstId + "&limit=4&intent=related")
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.products && data.products.length) {
            var recs = data.products.map(function (p) {
              var img = p.images && p.images[0] ? p.images[0].src : "";
              return {
                id: p.id,
                handle: p.handle,
                title: p.title,
                price: p.variants && p.variants[0] ? Math.round(parseFloat(p.variants[0].price) * 100) : 0,
                compare_at_price: p.compare_at_price ? Math.round(parseFloat(p.compare_at_price) * 100) : 0,
                url: "/products/" + p.handle,
                image: img,
                variants: (p.variants || []).map(function (v) {
                  return {
                    id: v.id,
                    title: v.title,
                    available: v.available,
                    price: Math.round(parseFloat(v.price) * 100),
                    compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
                  };
                }),
              };
            });
            var filtered = recs.filter(function (p) { return !cartIds[p.id]; });
            if (filtered.length) {
              upsellProducts = filtered;
              renderUpsellCards(filtered);
              return;
            }
          }
          upsellsEl.hidden = true;
        })
        .catch(function () {
          upsellsEl.hidden = true;
        });
      return;
    }

    if (qualified.length === 0) {
      upsellsEl.hidden = true;
      return;
    }

    renderUpsellCards(qualified);
  }

  function renderUpsellCards(products) {
    upsellsEl.hidden = false;
    upsellsList.innerHTML = products.map(function (p) {
      var img = p.image || "";
      var imgHtml = img
        ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">'
        : '<div class="cart-drawer__upsell-card-img-placeholder">No image</div>';

      // Always add-to-cart only (no redirect to product page).
      // Pick the first available variant, or fall back to the first one.
      var variants = p.variants || [];
      var chosen = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) { chosen = variants[i]; break; }
      }
      if (!chosen) chosen = variants[0] || null;
      var variantId = chosen ? chosen.id : "";
      var price = chosen && typeof chosen.price === "number" ? chosen.price : p.price;
      var compare = chosen && typeof chosen.compare_at_price === "number" && chosen.compare_at_price
        ? chosen.compare_at_price
        : (p.compare_at_price || 0);

      var priceHtml = '<span class="cart-drawer__upsell-card-price">' + formatMoney(price) + "</span>";
      if (compare && compare > price) {
        priceHtml =
          '<span class="cart-drawer__upsell-card-compare">' + formatMoney(compare) + "</span>" + priceHtml;
      }

      return (
        '<div class="cart-drawer__upsell-card">' +
        '<span class="cart-drawer__upsell-card-img">' + imgHtml + "</span>" +
        '<div class="cart-drawer__upsell-card-body">' +
        '<span class="cart-drawer__upsell-card-title">' + escapeHtml(p.title) + "</span>" +
        '<div class="cart-drawer__upsell-card-prices">' + priceHtml + "</div>" +
        '<div class="cart-drawer__upsell-card-controls">' +
        '<input type="number" class="cart-drawer__upsell-card-qty" data-upsell-qty value="1" min="1" step="1" aria-label="Qty">' +
        '<button type="button" class="cart-drawer__upsell-card-add" data-upsell-add data-product-id="' + p.id + '" data-variant-id="' + variantId + '">Add</button>' +
        "</div>" +
        "</div>" +
        "</div>"
      );
    }).join("");
  }

  function render(cart) {
    if (!cart || !cart.items) return;
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<li class="cart-drawer__empty">' + escapeHtml(emptyText) + "</li>";
    } else {
      itemsEl.innerHTML = cart.items.map(renderItem).join("");
    }
    subtotalEl.textContent = formatMoney(cart.total_price);
    renderWas(cart);
    renderFreeShipping(cart);
    renderUpsells(cart);
  }

  function updateCount(n) {
    document.querySelectorAll(".site-header__cart-count").forEach(function (el) {
      el.textContent = "(" + n + ")";
    });
  }

  function open() {
    initCountdown();
    lastFocusedEl = document.activeElement;
    panel.classList.add("is-open");
    backdrop.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-open");
    var first = panel.querySelector(focusableSelector);
    if (first) first.focus();
  }

  function close() {
    panel.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    panel.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-open");
    if (lastFocusedEl && lastFocusedEl.focus) {
      lastFocusedEl.focus();
      lastFocusedEl = null;
    }
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function reloadAndOpen() {
    fetchCart().then(function (cart) {
      render(cart);
      updateCount(cart.item_count);
      open();
    });
  }

  function changeItem(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
      body: new URLSearchParams({ id: key, quantity: qty }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function (cart) {
        render(cart);
        updateCount(cart.item_count);
      })
      .catch(function (err) {
        var msg = "Could not update cart";
        if (err && err.message) msg = err.message;
        else if (err && err.description) msg = err.description;
        else if (err && err.errors) msg = typeof err.errors === "string" ? err.errors : JSON.stringify(err.errors);
        window.alert(msg);
      });
  }

  function applyDiscount(code) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount_code: code }),
    })
      .then(function (r) {
        if (!r.ok) {
          var here = location.pathname + location.search;
          if (here.indexOf("cart=open") === -1) {
            here += (here.indexOf("?") >= 0 ? "&" : "?") + "cart=open";
          }
          window.location.href =
            shopUrl + "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(here);
          return null;
        }
        return r.json();
      })
      .catch(function () {
        var here = location.pathname + location.search;
        if (here.indexOf("cart=open") === -1) {
          here += (here.indexOf("?") >= 0 ? "&" : "?") + "cart=open";
        }
        window.location.href =
          shopUrl + "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(here);
        return null;
      });
  }

  var CartDrawer = {
    open: open,
    close: close,
    fetchCart: fetchCart,
    render: render,
    updateCount: updateCount,
    reloadAndOpen: reloadAndOpen,
    afterAdd: function (discountCode) {
      var code = (discountCode || "").trim();
      if (code) {
        applyDiscount(code).then(function (cart) {
          if (!cart) return;
          render(cart);
          updateCount(cart.item_count);
          open();
        });
        return;
      }
      reloadAndOpen();
    },
    formatMoney: formatMoney,
  };

  window.CartDrawer = CartDrawer;

  backdrop.addEventListener("click", close);

  var closeBtn = drawer.querySelector("[data-cart-drawer-close]");
  if (closeBtn) closeBtn.addEventListener("click", close);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var aria = panel.getAttribute("aria-hidden");
      if (aria === "false") close();
    }
  });

  panel.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var focusable = panel.querySelectorAll(focusableSelector);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-cart-drawer-open]");
    if (t) {
      e.preventDefault();
      fetchCart().then(function (cart) {
        render(cart);
        updateCount(cart.item_count);
        open();
      });
    }
  });

  if (itemsEl) {
    itemsEl.addEventListener("change", function (e) {
      var inp = e.target.closest("[data-cart-qty-input]");
      if (!inp) return;
      var key = inp.getAttribute("data-key");
      var qty = parseInt(inp.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeItem(key, qty);
    });

    itemsEl.addEventListener("click", function (e) {
      var step = e.target.closest("[data-cart-qty-step]");
      if (step) {
        e.preventDefault();
        var input = step.parentNode.querySelector("[data-cart-qty-input]");
        var nextQty = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute("data-cart-qty-step"), 10));
        input.value = String(nextQty);
        changeItem(input.getAttribute("data-key"), nextQty);
        return;
      }
      var bump = e.target.closest("[data-cart-qty-upsell]");
      if (bump) {
        e.preventDefault();
        changeItem(bump.getAttribute("data-key"), 2);
        return;
      }
      var rm = e.target.closest("[data-cart-remove]");
      if (!rm) return;
      e.preventDefault();
      changeItem(rm.getAttribute("data-key"), 0);
    });
  }

  if (upsellsList) {
    upsellsList.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-upsell-add]");
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;
      var card = btn.closest(".cart-drawer__upsell-card");
      var qtyInput = card && card.querySelector("[data-upsell-qty]");
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || "Could not add");
          });
          return r.json();
        })
        .then(function () {
          return fetchCart().then(function (cart) {
            render(cart);
            updateCount(cart.item_count);
          });
        })
        .catch(function (err) {
          window.alert(err.message || "Could not add to cart");
        });
    });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var _action = form.getAttribute("action") || "/cart/add";
    var _fd = new FormData(form);
    fetch(_action, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(_fd),
      redirect: "manual",
    })
      .then(function (r) {
        if (r.type === "opaqueredirect") {
          CartDrawer.reloadAndOpen();
          return;
        }
        if (!r.ok) return r.text();
        return null;
      })
      .then(function (errBody) {
        if (errBody != null) {
          var msg = "Could not add to cart";
          try {
            var j = JSON.parse(errBody);
            msg = j.description || j.message || (j.errors && typeof j.errors === "string" ? j.errors : j.errors && j.errors[0]) || (j.error || msg);
          } catch (_) {
            var m = errBody.match(/<title>([^<]+)<\/title>/i);
            if (m) msg = m[1];
          }
          window.alert(msg);
        }
      })
      .catch(function () {
        window.alert("Could not add to cart");
      });
  });

  if (/[?&]cart=open\b/.test(location.search)) {
    fetchCart().then(function (cart) {
      render(cart);
      updateCount(cart.item_count);
      open();
    });
    var s = location.search.replace(/[?&]cart=open\b/, "").replace(/^&/, "?").replace(/[?&]$/, "");
    if (s === "?") s = "";
    var cleaned = location.pathname + s + location.hash;
    history.replaceState(null, "", cleaned);
  }
})();
